const debugElement = document.querySelector('.debug');
const debugToggle = document.querySelector('.debug a.toggle');
if(debugElement && debugToggle) {
	debugToggle.style.cursor = 'pointer';
	debugToggle.addEventListener('click', (e)=>{
		e.preventDefault();
		debugElement.classList.toggle('open');
	});
}

  